// The main line of each White course, as SAN from the first move. Kept apart
// from the PGN text so the trainer can read the main lines without downloading
// every course body (each body is its own chunk, fetched when the course opens).

export const ITALIAN_MAINLINE = [
  "e4",
  "e5",
  "Nf3",
  "Nc6",
  "Bc4",
  "Bc5",
  "c3",
  "Nf6",
  "d3",
  "d6",
  "O-O",
  "O-O",
  "Re1",
  "a6",
  "Bb3",
  "Ba7",
  "h3",
  "h6",
  "Nbd2",
  "Re8",
  "Nf1",
  "Be6",
  "Ng3",
  "Qd7",
  "Bc2",
  "Rad8",
  "d4",
  "exd4",
  "cxd4",
  "d5",
] as const;

export const QUEENS_GAMBIT_MAINLINE = [
  "d4",
  "d5",
  "c4",
  "e6",
  "Nc3",
  "Nf6",
  "Bg5",
  "Be7",
  "e3",
  "O-O",
  "Nf3",
  "Nbd7",
  "Rc1",
  "c6",
  "Bd3",
  "dxc4",
  "Bxc4",
  "Nd5",
  "Bxe7",
  "Qxe7",
  "O-O",
  "Nxc3",
  "Rxc3",
  "e5",
  "dxe5",
  "Nxe5",
  "Nxe5",
  "Qxe5",
  "f4",
  "Qe4",
] as const;

export const RUY_LOPEZ_MAINLINE = [
  "e4",
  "e5",
  "Nf3",
  "Nc6",
  "Bb5",
  "a6",
  "Ba4",
  "Nf6",
  "O-O",
  "Be7",
  "Re1",
  "b5",
  "Bb3",
  "d6",
  "c3",
  "O-O",
  "h3",
  "Na5",
  "Bc2",
  "c5",
  "d4",
  "Qc7",
  "Nbd2",
  "cxd4",
  "cxd4",
  "Nc6",
  "d5",
  "Nb8",
  "a4",
  "Nbd7",
] as const;

export const ENGLISH_MAINLINE = [
  "c4",
  "e5",
  "Nc3",
  "Nf6",
  "g3",
  "d5",
  "cxd5",
  "Nxd5",
  "Bg2",
  "Nb6",
  "Nf3",
  "Nc6",
  "O-O",
  "Be7",
  "d3",
  "O-O",
  "a3",
  "Be6",
  "b4",
  "a5",
  "b5",
  "Nd4",
  "Nd2",
  "Qc8",
  "e3",
  "Nf5",
  "Qc2",
  "Rd8",
  "Bb2",
  "f6",
] as const;

export const LONDON_MAINLINE = [
  "d4",
  "d5",
  "Bf4",
  "Nf6",
  "e3",
  "e6",
  "Nf3",
  "Bd6",
  "Bg3",
  "O-O",
  "Bd3",
  "c5",
  "c3",
  "Nc6",
  "Nbd2",
  "b6",
  "O-O",
  "Bb7",
  "Qe2",
  "Qc7",
  "Rad1",
  "Rad8",
  "Bxd6",
  "Qxd6",
  "e4",
  "dxe4",
  "Nxe4",
  "Nxe4",
  "Bxe4",
  "cxd4",
] as const;

export const ALAPIN_MAINLINE = [
  "e4",
  "c5",
  "c3",
  "d5",
  "exd5",
  "Qxd5",
  "d4",
  "Nf6",
  "Nf3",
  "e6",
  "Be2",
  "Nc6",
  "O-O",
  "cxd4",
  "cxd4",
  "Be7",
  "Nc3",
  "Qd6",
  "Nb5",
  "Qd8",
  "Bf4",
  "Nd5",
  "Bg3",
  "O-O",
  "Rc1",
  "Bd7",
  "Nc3",
  "Rc8",
  "a3",
  "Bf6",
] as const;

export const VIENNA_MAINLINE = [
  "e4",
  "e5",
  "Nc3",
  "Nf6",
  "f4",
  "d5",
  "fxe5",
  "Nxe4",
  "Nf3",
  "Be7",
  "d4",
  "O-O",
  "Bd3",
  "f5",
  "exf6",
  "Bxf6",
  "O-O",
  "Nc6",
  "Ne2",
  "Nb4",
  "Bb5",
  "Bd7",
  "Bxd7",
  "Qxd7",
  "c3",
  "Nc6",
  "Ng3",
  "Rae8",
  "Bf4",
  "h6",
] as const;

export const SCOTCH_MAINLINE = [
  "e4",
  "e5",
  "Nf3",
  "Nc6",
  "d4",
  "exd4",
  "Nxd4",
  "Nf6",
  "Nxc6",
  "bxc6",
  "e5",
  "Qe7",
  "Qe2",
  "Nd5",
  "c4",
  "Ba6",
  "b3",
  "g6",
  "Bb2",
  "Bg7",
  "g3",
  "O-O-O",
  "Nd2",
  "d6",
  "Bh3+",
  "Kb8",
  "O-O",
  "dxe5",
  "Nf3",
  "Rhe8",
] as const;

export const FOUR_KNIGHTS_MAINLINE = [
  "e4",
  "e5",
  "Nf3",
  "Nc6",
  "Nc3",
  "Nf6",
  "Bb5",
  "Bb4",
  "O-O",
  "O-O",
  "d3",
  "d6",
  "Bg5",
  "Bxc3",
  "bxc3",
  "Qe7",
  "Re1",
  "Nd8",
  "d4",
  "Ne6",
  "Bc1",
  "c5",
  "d5",
  "Nc7",
  "Bd3",
  "Nfe8",
  "c4",
  "f5",
  "exf5",
  "Bxf5",
] as const;

export const RETI_MAINLINE = [
  "Nf3",
  "d5",
  "c4",
  "e6",
  "g3",
  "Nf6",
  "Bg2",
  "Be7",
  "O-O",
  "O-O",
  "b3",
  "c5",
  "Bb2",
  "Nc6",
  "e3",
  "d4",
  "exd4",
  "cxd4",
  "Re1",
  "Re8",
  "d3",
  "Bc5",
  "Ba3",
  "Nd7",
  "Bxc5",
  "Nxc5",
  "Ne5",
  "Nxe5",
  "Rxe5",
  "Qc7",
] as const;

export const OPEN_SICILIAN_MAINLINE = [
  "e4",
  "c5",
  "Nf3",
  "d6",
  "d4",
  "cxd4",
  "Nxd4",
  "Nf6",
  "Nc3",
  "a6",
  "Be2",
  "e5",
  "Nb3",
  "Be7",
  "O-O",
  "O-O",
  "Be3",
  "Be6",
  "Qd2",
  "Nbd7",
  "a4",
  "Rc8",
  "a5",
  "Qc7",
  "Rfd1",
  "Rfd8",
  "h3",
  "h6",
  "Bf3",
  "b5",
] as const;

export const PIRC_MAINLINE = [
  "e4",
  "d6",
  "d4",
  "Nf6",
  "Nc3",
  "g6",
  "Nf3",
  "Bg7",
  "Be2",
  "O-O",
  "O-O",
  "c6",
  "a4",
  "Nbd7",
  "h3",
  "e5",
  "Re1",
  "Qc7",
  "Be3",
  "Re8",
  "Qd2",
  "exd4",
  "Nxd4",
  "Nc5",
  "Bf3",
  "a5",
  "Rad1",
  "Be6",
  "Bf4",
  "Nfd7",
] as const;

export const KINGS_GAMBIT_MAINLINE = [
  "e4",
  "e5",
  "f4",
  "exf4",
  "Nf3",
  "d5",
  "exd5",
  "Nf6",
  "c4",
  "c6",
  "d4",
  "Bb4+",
  "Nc3",
  "cxd5",
  "Bxf4",
  "O-O",
  "Be2",
  "dxc4",
  "Bxc4",
  "Nc6",
  "O-O",
  "Bg4",
  "a3",
  "Ba5",
  "Kh1",
  "Bxf3",
  "Qxf3",
  "Qxd4",
  "Ba2",
  "Bxc3",
] as const;

export const FRENCH_ADVANCE_MAINLINE = [
  "e4",
  "e6",
  "d4",
  "d5",
  "e5",
  "c5",
  "c3",
  "Nc6",
  "Nf3",
  "Qb6",
  "a3",
  "cxd4",
  "cxd4",
  "Nge7",
  "Nc3",
  "Nf5",
  "Na4",
  "Qa5+",
  "b4",
  "Qc7",
  "Bb2",
  "Bd7",
  "Rc1",
  "Qd8",
  "Bd3",
  "Be7",
  "O-O",
  "O-O",
  "Nc5",
  "Bxc5",
] as const;

export const SCANDINAVIAN_MAINLINE = [
  "e4",
  "d5",
  "exd5",
  "Qxd5",
  "Nc3",
  "Qa5",
  "d4",
  "Nf6",
  "Nf3",
  "Bg4",
  "h3",
  "Bh5",
  "g4",
  "Bg6",
  "Ne5",
  "e6",
  "h4",
  "Bb4",
  "Bd2",
  "Nbd7",
  "Nc4",
  "Qa6",
  "h5",
  "Bxc3",
  "Bxc3",
  "Be4",
  "Rh3",
  "h6",
  "Ne5",
  "Qa4",
] as const;

export const CARO_ADVANCE_MAINLINE = [
  "e4",
  "c6",
  "d4",
  "d5",
  "e5",
  "Bf5",
  "Nf3",
  "e6",
  "Be2",
  "c5",
  "Be3",
  "cxd4",
  "Nxd4",
  "Ne7",
  "c4",
  "Nbc6",
  "Qa4",
  "a6",
  "Nc3",
  "dxc4",
  "O-O-O",
  "Qa5",
  "Qxa5",
  "Nxa5",
  "Nxf5",
  "Nxf5",
  "Bb6",
  "Nc6",
  "f4",
  "Rc8",
] as const;

export const QUIET_TWO_KNIGHTS_MAINLINE = [
  "e4",
  "e5",
  "Nf3",
  "Nc6",
  "Bc4",
  "Nf6",
  "d3",
  "Be7",
  "O-O",
  "O-O",
  "Re1",
  "d6",
  "c3",
  "Na5",
  "Bb3",
  "c5",
  "Nbd2",
  "Nc6",
  "Nf1",
  "Be6",
  "Ng3",
  "Qc7",
  "h3",
  "Rad8",
  "Be3",
  "b6",
  "Qd2",
  "Rfe8",
  "Rad1",
  "a6",
] as const;
